"use client";

import React, { useEffect } from "react"

interface Props {
  title: string
  type: string
  description: string
  url?: string
  siteName?: string
  image?: string
  cover?: string
}

export const OpenGraphSEO = ({
  title,
  type,
  description,
  url,
  siteName,
  image,
  cover,
}: Props) => {
  useEffect(() => {
    // Helper function to add or update meta tags
    const updateMeta = (property: string, content: string | undefined) => {
      if (!content) return;
      
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Update all OpenGraph meta tags
    updateMeta('og:title', title);
    updateMeta('og:type', type);
    updateMeta('og:description', description);
    updateMeta('og:url', url);
    updateMeta('og:site_name', siteName);
    updateMeta('og:image', image ?? cover);
  }, [title, type, description, url, siteName, image, cover]);

  return null;
}